<template>
  <div class="account-setting">
    <van-form @submit="onSubmit" style="height: 80vh">
      <van-field
        v-model="fullName"
        name="fullName"
        label="合作伙伴名称"
        placeholder="请输入合作伙伴名称"
        :rules="[{ required: true, message: '请填写合作伙伴名称' }]"
      />
      <van-field
        label="户主姓名"
        v-model="masterName"
        name="masterName"
        placeholder="请输入户主姓名"
        :rules="[{ required: true, message: '请填写户主姓名' }]"
      />
      <van-field
        label="手机号码"
        v-model="phone"
        name="phone"
        placeholder="请输入手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }]"
      />
      <div v-if="!type" style="width: 65%; margin: 0 auto; margin-top: 20rem">
        <van-button round block type="info" native-type="submit"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { create } from "@/api/subordinate";

export default {
  data() {
    return {
      fullName: "",
      masterName: "",
      phone: "",
      type: "",
    };
  },
  mounted() {
    if (this.$route.query.items != null) {
      this.fullName = this.$route.query.items.fullName;
      this.masterName = this.$route.query.items.name;
      this.phone = this.$route.query.items.phone;
      this.type = this.$route.query.type;
    }
  },
  methods: {
    onSubmit(values) {
      const data = {
        fullName: values.fullName,
        masterName: values.masterName,
        name: values.fullName,
        phone: values.phone,
      };
      create(data)
        .then((res) => {
          //   console.log("创建下级门店", res);
          if (res.code == 0) {
            this.$toast("创建成功!");
            this.$router.push({
              name: "storesdata",
            });
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  width: 90%;
  margin: 0 auto;
  margin-top: 1rem;
}
</style>
